import ListHorariosImpl from "components/horarios/ListHorariosImpl";
import React from "react";
import { Col, Row } from "reactstrap";

const ViewHorarios = () => {
  return (<Row>
        <Col>
        <ListHorariosImpl></ListHorariosImpl>
        </Col>
    </Row>
  );
};

export default ViewHorarios;
